/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";

import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import ModalProvider from "../_layout/_partials/use-modal/ModalProvider";
import { LayoutSplashScreen } from "../_layout/layout";
import { Routes } from "../app/Routes";

export default function App({ store, persistor, basename }) {
  return (
    <Provider store={store}>
      <ModalProvider>
        <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
          <React.Suspense fallback={<LayoutSplashScreen />}>
            <BrowserRouter basename={basename}>
              <Routes />
            </BrowserRouter>
          </React.Suspense>
        </PersistGate>
      </ModalProvider>
    </Provider>
  );
}
